import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  snackBar: {
    marginBottom: "25px",
    margin: "10px"
  }
}));
